import styled from "styled-components"
import { COLOR } from "utils/color"

export const KeeperDevicesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 14px;
`

export const KeeperDeviceCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  align-items: center;
  height: 260px;
  width: 260px;
  padding: 10px;
  margin-bottom: 0;
  position: relative;
  background: white;
  border: 1px solid ${COLOR.WHITE_SMOKE};
  box-shadow: 1px 2px 3px rgba(196, 196, 196, 0.12);
`

export const KeeperDeviceHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${COLOR.MEDIUM_LIGHT_GREY};
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export const KeeperDeviceContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  font-size: 13px;
  margin-top: 20px;
  color: ${COLOR.BLACK};
`

export const DeviceMeta = styled.div`
  font-size: 12px;
  color: ${COLOR.BLACK};
`

export const SmallText = styled.div`
  font-size: 12px;
  color: ${COLOR.BLACK};
`
